import styled from "styled-components";

import Record from "../Record";
import CellBox from "../../../../components/CellBox";
import useAccount from "../../hook";
import Notice from "./Notice";
import { Calendar } from "react-vant";
import { Modal, Toast } from "antd-mobile";
import { useMemo } from "react";
import { useState } from "react";
import { useEffect } from "react";
import { fmoney, getDay, date2block } from "../../../../utils/utils";
import { useIntl } from "react-intl";
export default function LotteryTab() {
  const [rangeDate, setRangeDate] = useState(() => {
    const now = Date.now();
    const endDate = getDay(now, 0);
    const startDate = getDay(now, -30);
    return [new Date(startDate), new Date(endDate)];
  });
  const { getLotteries, claimLotteryReward, getLotteryStatistics, myAccount } =
    useAccount();
  const [ls, setLs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [lotteryStatustics, setLotteryStatustics] = useState({
    rb: 0,
    rbct: 0,
    rbet: 0,
  });
  const intl = useIntl();
  const cellData = useMemo(() => {
    return [
      {
        icon: "/image/RB.png",
        label: "RT",
        text: fmoney(lotteryStatustics.rb || 0, 2),
      },
      {
        icon: "/image/quility_chip.png",
        label: intl.formatMessage({
          id: "pages.account.lottery_card_chip",
          defaultMessage: "属性卡碎片",
        }),
        text: fmoney(lotteryStatustics.rbct || 0, 2),
      },
      {
        icon: "/image/equip_chip.png",
        label: intl.formatMessage({
          id: "pages.account.lottery_equip_chip",
          defaultMessage: "装备碎片",
        }),
        text: fmoney(lotteryStatustics.rbet || 0, 2),
      },
    ];
  }, [lotteryStatustics]);

  useEffect(() => {
    if (myAccount && myAccount.account) {
      init();
    }
  }, []);
  const init = () => {
    loadLotteries();
    getLotteryStatistics().then((res) => {
      console.log("setLotteryStatustics", res);
      setLotteryStatustics(res);
    });
  };
  const showNotice = (item) => {
    const m = Modal.show({
      title: intl.formatMessage({
        id: "pages.account.lottery_notice_title",
        defaultMessage: "通知",
      }),
      bodyClassName: "runbit_modal",
      showCloseButton: true,
      actions: [
        {
          key: "prev",
          className: "border_btn",
          text: intl.formatMessage({
            id: "common.cancel",
            defaultMessage: "取消",
          }),
        },
        {
          key: "confrim",
          className: "primary_btn",
          text: intl.formatMessage({
            id: "pages.account.lottery_notice_confrim",
            defaultMessage: "領取",
          }),
          primary: true,
        },
      ],
      onAction: async (action, index) => {
        m.close();
        if (action.key === "confrim") {
          await claimLotteryReward(item);
          init();
        }
      },
      closeOnAction: false,
      content: <Notice item={item} />,
    });
  };
  const loadLotteries = async (startDate, endDate) => {
    setLoading(true);
    const start = date2block(startDate || rangeDate[0]);
    const end = date2block(endDate || rangeDate[1]);
    const ls = await getLotteries(start, end);
    setLs(ls);
    setLoading(false);
  };

  const recordClick = (item) => {
    if (item.status) {
      Toast.show(
        intl.formatMessage({
          id: "pages.account.lottery_received",
          defaultMessage: "已領獎",
        })
      );
      return;
    }
    showNotice(item);
  };
  return (
    <Container>
      <Flex2 style={{ marginBottom: "1.0rem" }}>
        <img
          className="avatar"
          style={{ width: "3.8rem" }}
          src="/image/default_avatar.png"
          alt="avatar"
        />
        <Text>
          {intl.formatMessage({
            id: "pages.account.lottery_accumulated",
            defaultMessage: "累計獲獎",
          })}
        </Text>
      </Flex2>
      <CellBox list={cellData} />

      <Flex>
        <Text>
          {intl.formatMessage({
            id: "pages.account.lottery_record",
            defaultMessage: "獲獎記錄",
          })}
        </Text>
        <Calendar
          type="range"
          minDate={new Date(2020, 0, 1)}
          value={rangeDate}
          onConfirm={(data) => {
            console.log("rangeDate", data);
            setRangeDate([data[0], data[1]]);
            loadLotteries(data[0], data[1]);
          }}
          maxDate={new Date()}
        >
          {(val, actions) => (
            <HJRecord onClick={() => actions.open()}>
              {val
                ? val.map((el) => el.toLocaleDateString()).join("~")
                : intl.formatMessage({
                    id: "pages.account.lottery_select_date",
                    defaultMessage: "请选择日期",
                  })}
            </HJRecord>
          )}
        </Calendar>
      </Flex>
      <Record loading={loading} list={ls} onClick={recordClick} />
    </Container>
  );
}

const Container = styled.div`
  padding: 2.0rem .7rem;
`;
const Text = styled.div`
  font-weight: 600;
  font-size: 1.8rem;
  line-height: 2.0rem;
  display: inline-block;
  vertical-align: super;
  margin-left: 1.0rem;
`;

const Flex2 = styled.div`
  display: flex;
  align-items: center;
`;
const Flex = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 2.0rem;
  align-items: center;
  margin-top: 2.0rem;
`;

const HJRecord = styled.div`
  border-radius: 1.2rem;
  border: .15rem solid #000;
  padding: 2px 1.0rem;
`;

const Btn2 = styled.div`
  background: #ed7335;
  width: 9.5rem;
  border: .15rem solid #000;
  color: #fff;
  border-radius: 1.2rem;
  text-align: center;
  height: 2.1rem;
  line-height: 2.1rem;
`;
